import { render, staticRenderFns } from "./DPHV.vue?vue&type=template&id=ec9a979c&scoped=true"
import script from "./DPHV.vue?vue&type=script&lang=js"
export * from "./DPHV.vue?vue&type=script&lang=js"
import style0 from "./DPHV.vue?vue&type=style&index=0&id=ec9a979c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9a979c",
  null
  
)

export default component.exports